export const normalizeNumberInputValue = (value: string) =>
  value.trim().replace(/,/g, '.');

export const parseNumberInputValue = (value: string) => {
  const normalizedValue = normalizeNumberInputValue(value);

  if (!normalizedValue) {
    return undefined;
  }

  const parsedValue = Number(normalizedValue);

  return Number.isFinite(parsedValue) ? parsedValue : undefined;
};
